export const ROLE_RANGE_LIST = [{
    label: "전체",
    value: "ALL",
  },
  {
    label: "최상위 부서부터 하위",
    value: "TOP",

  },
  {
    label: "상위 부서부터 하위",
    value: "HIGH",

  },
  {
    label: "본인 부서만",
    value: "PART",

  },
  {
    label: "본인 부서부터 하위",
    value: "LOW",
  },
  {
    label: "본인만",
    value: "MINE",

  },
]

export const TYPE_LIST = [{
    label: '직원',
    value: 0
  },
  {
    label: '대표',
    value: 1
  },
  {
    label: '경리',
    value: 2
  },
  {
    label: '노무사',
    value: 3
  },
  {
    label: '세무사',
    value: 4
  },
  {
    label: '직원',
    value: 5
  },
  {
    label: '경리대행',
    value: 9
  },
]

// 전체
export const ALL_TYPES = TYPE_LIST.map(t => t.value)

// 어드민
export const ADMIN_TYPES = [1, 2, 4, 9]

// 세무 담당자만 보이게
export const TAX_ADMIN_TYPES = [4, 9]

// 노무 관련 어드민
export const WORK_ADMIN_TYPES = [...ADMIN_TYPES, 3]